import { render } from "./FormTemplate.vue?vue&type=template&id=db7768d0&scoped=true"
import script from "./FormTemplate.vue?vue&type=script&lang=js"
export * from "./FormTemplate.vue?vue&type=script&lang=js"

import "./FormTemplate.vue?vue&type=style&index=0&id=db7768d0&lang=scss&scoped=true"
import "./FormTemplate.vue?vue&type=style&index=1&id=db7768d0&lang=scss"

import exportComponent from "D:\\source\\Mobaxe.Docs.App\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db7768d0"],['__file',"src/views/FormTemplate.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "db7768d0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('db7768d0', __exports__)) {
    console.log('reload')
    api.reload('db7768d0', __exports__)
  }
  
  module.hot.accept("./FormTemplate.vue?vue&type=template&id=db7768d0&scoped=true", () => {
    console.log('re-render')
    api.rerender('db7768d0', render)
  })

}


export default __exports__